export interface SecurityRole {
  ID: number;
  name: string;
};